import { useState } from "react";
import { Button, Tooltip, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import downloadBlob from "../utils/download-blob";

type ExportCsvButtonProps = {
    /** Gọi API xuất, trả về response axios với responseType "blob". */
    request: () => Promise<{ data: BlobPart }>;
    /** Tiền tố tên file tải về (sẽ nối thêm timestamp). */
    filename: string;
    /** Nhãn nút; mặc định "Xuất CSV". */
    label?: string;
    /** Tooltip giải thích file chứa gì. */
    tooltip?: string;
    disabled?: boolean;
    className?: string;
};

/**
 * Nút "Xuất CSV" dùng chung cho các màn danh sách của admin.
 * File tải về là TOÀN BỘ kết quả đang lọc (server stream), không phải trang
 * đang xem — để admin cộng tổng trong Excel và đối chiếu với số trên màn hình.
 */
function ExportCsvButton({
    request,
    filename,
    label = "Xuất CSV",
    tooltip = "Tải toàn bộ kết quả đang lọc ra CSV để tự cộng tổng trong Excel",
    disabled,
    className,
}: ExportCsvButtonProps) {
    const [loading, setLoading] = useState(false);

    const onExport = async () => {
        setLoading(true);
        try {
            const res = await request();
            downloadBlob(res.data, `${filename}-${Date.now()}.csv`);
        } catch (e: any) {
            // Lỗi trả về là blob (responseType blob) nên phải đọc text mới thấy message.
            // Lỗi từ nginx (502/504) là trang HTML → JSON.parse văng ngay trong catch,
            // nút im lặng không báo gì; nên parse cũng phải nằm trong try.
            let parsed = null;
            try {
                const text = await e?.response?.data?.text?.();
                parsed = text ? JSON.parse(text)?.message : null;
            } catch {
                /* bỏ qua */
            }
            const status = e?.response?.status;
            message.error(parsed || `Xuất CSV thất bại${status ? ` (lỗi ${status})` : ""} — thử lại hoặc thu hẹp bộ lọc`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title={tooltip}>
            <Button
                icon={<FontAwesomeIcon icon={faFileCsv} />}
                loading={loading}
                disabled={disabled}
                onClick={onExport}
                className={className}
            >
                {label}
            </Button>
        </Tooltip>
    );
}

export default ExportCsvButton;
